module.exports = __webpack_public_path__ + "img/2.0a2b8c74.png";